import { Button, Card, Col, Placeholder, Row } from "react-bootstrap";
import { faChevronDown, faChevronUp, faSpinner, faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { faThumbsDown as faThumbsDownOutline, faThumbsUp as faThumbsUpOutline } from "@fortawesome/free-regular-svg-icons";
import { LLMVisitFeedback } from "../../../../amplify/api-gateway/query";
import { useMemo, useState } from "react";
import { LLMDashboardFeedbackModal } from "./LLMDashboardFeedbackModal";
import { PatientVisit } from "../../../../amplify/api-gateway/search-patients";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callWrite, UPDATE_LLM_VISIT_FEEDBACK } from "../../../../amplify/api-gateway/write";

export const LLMDashboardFeedbackBar = (props: {
    patientVisit?: PatientVisit,
    feedbackTarget: string,
    feedbacks: LLMVisitFeedback[] | undefined,
    setFeedbacks: any,
}) => {

    const [showModal, setShowModal] = useState(false);
    const [feedbackType, setFeedbackType] = useState("");
    const [submittingPositive, setSubmittingPositive] = useState(false);
    const [submittingNegative, setSubmittingNegative] = useState(false);

    const existingReview = useMemo(() => {
        const feedbackList = props.feedbacks ?? [];
        let existing: LLMVisitFeedback | undefined;
        for (let review of feedbackList) {
            if (review.feedback_target === props.feedbackTarget) {
                existing = review;
                setFeedbackType(review.feedback_type);
            }
        }
        return existing;
    }, [props.feedbacks, props.feedbackTarget]);

    const handleFeedback = async (isPositive: boolean) => {
        let feedbackType;
        if (isPositive) {
            setSubmittingPositive(true);
            feedbackType = "positive";
        } else {
            setSubmittingNegative(true);
            feedbackType = "negative";
        }
        if (props.patientVisit) {
            callWrite({
                operation: UPDATE_LLM_VISIT_FEEDBACK,
                creation_time: new Date().getTime(),
                csn: props.patientVisit.csn,
                mrn: props.patientVisit.mrn,
                feedback_target: props.feedbackTarget,
                feedback_type: feedbackType,
                note: existingReview ? existingReview.note : "",
            }).then((response) => {
                if (isPositive) {
                    setSubmittingPositive(false);
                } else {
                    setSubmittingNegative(false);
                }

                // Check if response is empty or has an error
                if (!response || Object.keys(response).length === 0) {
                    window.alert("Failed to submit feedback. Server returned an empty response.");
                    return false;
                }
                const feedbackList = props.feedbacks ?? [];
                props.setFeedbacks([
                    ...feedbackList,
                    response[0],
                ]);
            });
        }
        setShowModal(true);
    }

    return (
        <span onClick={(e) => {e.stopPropagation();}}>
            <Button
                variant="primary"
                className={`dashboard-round-btn ${existingReview?.feedback_type === "positive" && "dashboard-reviewed"}`}
                onClick={(e: any) => {
                    e.stopPropagation();
                    handleFeedback(true);
                }}
                disabled={submittingPositive}
            >
                {
                    submittingPositive ? (
                        <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                        <>
                            {/* @ts-ignore */}
                            <FontAwesomeIcon icon={existingReview?.feedback_type === "positive" ? faThumbsUp : faThumbsUpOutline} />
                        </>
                    )
                }
            </Button>
            <Button
                variant="primary"
                className={`dashboard-round-btn ${existingReview?.feedback_type === "negative" && "dashboard-reviewed"}`}
                onClick={(e: any) => {
                    e.stopPropagation();
                    handleFeedback(false);
                }}
                disabled={submittingNegative}
            >
                {
                    submittingNegative ? (
                        <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                        <>
                            {/* @ts-ignore */}
                            <FontAwesomeIcon icon={existingReview?.feedback_type === "negative" ? faThumbsDown : faThumbsDownOutline} />
                        </>
                    )
                }
            </Button>
            {
                props.patientVisit && (
                    <LLMDashboardFeedbackModal showModal={showModal} setShowModal={setShowModal} patientVisit={props.patientVisit} feedbackType={feedbackType} feedbackTarget={props.feedbackTarget} existingReview={existingReview} feedbacks={props.feedbacks} setFeedbacks={props.setFeedbacks} />
                )
            }
        </span>
    );
};
